import { useSearchParams } from "react-router-dom";
import { useSEO, buildBreadcrumbsJsonLd } from "../lib/seo";
import { useSiteTexts } from "../lib/siteTexts";
import { COMPANY, SITE_URL } from "../lib/constants";
import { PAGE_TEXTS } from "../data/pageTexts";
import { FORM_TOPICS, TOPIC_BY_ID } from "../data/contact";
import { SectionHeading } from "../components/home/CtaButtons";
import { ContactAside, ContactHero } from "../components/contact/ContactBlocks";
import { TopicPicker, TopicRoute } from "../components/contact/TopicPicker";
import { ContactForm } from "../components/contact/ContactForm";

const cfg = PAGE_TEXTS.contact;

const contactLd = (seo) => ({
  "@context": "https://schema.org", "@type": "ContactPage", name: seo.title, description: seo.body, url: SITE_URL + cfg.path, inLanguage: "nl-NL",
  mainEntity: { "@type": "HomeAndConstructionBusiness", "@id": `${SITE_URL}/#localbusiness`, name: COMPANY.name, telephone: COMPANY.phone, email: COMPANY.email,
    contactPoint: [{ "@type": "ContactPoint", contactType: "customer service", telephone: COMPANY.phone, email: COMPANY.email, areaServed: "NL", availableLanguage: ["nl"] }] },
});

export default function Contact() {
  const t = useSiteTexts("contact");
  const seo = t(cfg.blocks.seo);
  const crumbs = [{ label: "Home", href: "/" }, { label: "Contact", href: cfg.path }];
  useSEO({ title: seo.title, description: seo.body, path: cfg.path, jsonLd: contactLd(seo), breadcrumbs: buildBreadcrumbsJsonLd(crumbs) });
  const [params, setParams] = useSearchParams();
  const topic = TOPIC_BY_ID[params.get("onderwerp")] ? params.get("onderwerp") : "vraag";
  const current = TOPIC_BY_ID[topic];
  const choose = (id) => setParams(id === "vraag" ? {} : { onderwerp: id }, { replace: true, preventScrollReset: true });

  return (
    <div data-testid="contact-page">
      <ContactHero crumbs={crumbs} block={t(cfg.blocks.hero)} />
      <section id="onderwerp" aria-labelledby="onderwerp-title" className="section scroll-mt-28 border-t border-slate-200 bg-slate-50">
        <div className="container-tight grid gap-10 lg:grid-cols-12">
          <div className="min-w-0 lg:col-span-8">
            <SectionHeading id="onderwerp-title" eyebrow="Waar kunnen we u mee helpen?" title="Kies uw onderwerp" lead="Zo komt uw vraag direct op de juiste plek terecht." />
            <div className="mt-8"><TopicPicker value={topic} onChange={choose} /></div>
            <div className="mt-8 grid gap-6" aria-live="polite">
              {current.route && <TopicRoute topic={current} />}
              {FORM_TOPICS.includes(topic) && <ContactForm key={topic} topic={topic} />}
            </div>
          </div>
          <div className="lg:col-span-4"><ContactAside /></div>
        </div>
      </section>
    </div>
  );
}
